import { useMemo, useRef, useState, useEffect } from 'react'
import Wrapper from './VisualizeByNameFilterCard.styles'
import { Badge, BADGE_TYPE_NEUTRAL_DEFAULT } from '@mds/mds-reactjs-library'
import {
  getAssetClassSelectionDisplayCount,
  isLiveDashboardAssetClassDimension,
} from './liveDashboardAssetClass'
import {
  isLiveDashboardCurrencyDimension,
  parseCurrencySelectionToCode,
} from './liveDashboardCurrency'

const VisualizeByNameFilterCard = ({
  chart,
  dimension,
  selection,
  setFilterPanelIsOpen,
  setOpenAccordionDimensionId,
}) => {
  const selectionCount = useMemo(() => {
    const attributeIds = selection?.Attributes
    if (!Array.isArray(attributeIds)) {
      return 0
    }

    if (isLiveDashboardAssetClassDimension(chart, dimension)) {
      return getAssetClassSelectionDisplayCount(dimension, attributeIds)
    }

    return attributeIds.length
  }, [chart, dimension, selection?.Attributes])

  const currencyCode = useMemo(() => {
    if (!isLiveDashboardCurrencyDimension(chart, dimension)) {
      return null
    }
    return parseCurrencySelectionToCode(selection?.Attributes, dimension)
  }, [chart, dimension, selection?.Attributes])

  const filterCardClicked = () => {
    setOpenAccordionDimensionId(dimension.DimensionID)
    setFilterPanelIsOpen(true)
  }

  const labelRef = useRef(null)
  const [isTruncated, setIsTruncated] = useState(false)

  useEffect(() => {
    const el = labelRef.current
    if (el) {
      setIsTruncated(el.scrollWidth > el.offsetWidth)
    }
  })

  return (
    <Wrapper onClick={filterCardClicked}>
      <p ref={labelRef} title={isTruncated ? dimension.DisplayName : undefined}>{dimension.DisplayName}</p>
      {currencyCode ? (
        <Badge type={BADGE_TYPE_NEUTRAL_DEFAULT}>{currencyCode}</Badge>
      ) : (
        <Badge type={BADGE_TYPE_NEUTRAL_DEFAULT} numeric>
          {selectionCount}
        </Badge>
      )}
    </Wrapper>
  )
}

export default VisualizeByNameFilterCard
